var _desc, _defs, _rect, _rect2, _rect3, _use, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 220 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flag of Israel")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "0,-29.1410161513775421 -25.2368602791855814, 14.5705080756887710 25.2368602791855814, 14.5705080756887710",
    stroke: "#0038b8",
    strokeWidth: 5.5,
    fillOpacity: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 160,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 25,
    fill: "#0038b8",
    y: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 25,
    fill: "#0038b8",
    y: 120
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#triangle",
    transform: "translate(110,80)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#triangle",
    transform: "translate(110,80) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.927acd2009fa97938ab4a7ffcb90f3ea.svg";
export { ForwardRef as ReactComponent };